import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box, Grid, Button, Typography, Stepper, Step, StepLabel,
} from "@mui/material";
import {
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  NavigateNext as NavigateNextIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import StepConnector from "@mui/material/StepConnector";
import GRNStep1 from "./GRNStep1";
import GRNStep2 from "./GRNStep2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import AuthHeader from "../../../Auth";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from "../../../GlobalFunction/CrudButtons";
import axiosInstance from "../../../lib/axios";
import { useReactToPrint } from 'react-to-print';
import GRNPrintView from './GRNPrintView';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
const steps = ["Main", "Item Details"];

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-line": {
    borderColor: "#e0e0e0",
    borderTopWidth: 3,
    borderRadius: 1,
    margin: "7px 30px 20px 30px",
  },
}));

const CustomStepIcon = styled("div")(({ theme, ownerState }) => ({
  width: 40,
  height: 40,
  border: "3px solid",
  borderColor: ownerState.active ? "#635bff" : "#e0e0e0",
  borderRadius: "50%",
  backgroundColor: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: ownerState.active ? "#635bff" : "#999",
  fontSize: "1.2rem",
  fontWeight: "bold",
}));

const CustomStepLabel = styled(StepLabel)({
  flexDirection: "column",
  "& .MuiStepLabel-labelContainer": {
    marginTop: "5px",
  },
});

const GRNMst = () => {
  const location = useLocation();
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const navigate = useNavigate();
  const [UserLoginId] = useState(sessionStorage.getItem('UserId') || "100");
  const [activeStep, setActiveStep] = useState(0);
  const [mode, setMode] = useState("view");
  const [CompanyData, setCompanyData] = useState([]);
  const [Index] = useState(0);
  const [AllTextDisabled, setAllTextDisabled] = useState(true);
  const [AllButtonDisabled, setAllButtonDisabled] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [AllfieldStepperData, setAllfieldStepperData] = useState({});
  const [GooodsId, setGooodsId] = useState(-1);
  const [openDialog, setopenDialog] = useState(false);
  const [Flag, setFlag] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        if (location.state?.GooodsId) {
          setGooodsId(location.state.GooodsId);
          await fetchGoodsData(location.state.GooodsId, "R");
          setMode(location.state.mode || "view");
        } else {
          setMode("add");
          addModeDis();
        }
      } catch (error) {
        toast.error("Failed to initialize component");
      }
    };
    fetch();
  }, [location.state]);

  const viewModeDis = () => {
    setAllTextDisabled(true);
    setAllButtonDisabled(false);
  };

  const addModeDis = () => {
    setAllTextDisabled(false);
    setAllButtonDisabled(true);
  };

  const handleCancel = async () => {
    if (GooodsId !== -1) {
      await UnLock(GooodsId, "TrnSgrn", "SgrnId");
    }
    setopenDialog(false);
  };

  const fetchGoodsData = async (GooodsId, flag) => {
    try {
      const response = await axiosInstance.post("TrnSgrn/RetriveTrnSgrnAll", {
        SgrnId: GooodsId,
        Flag: flag,
        "CreatedBy": UserId,
      });

      if (response.data.Status === 0 && response.data.Data?.TrnSgrnList?.length > 0) {
        const data = response.data.Data.TrnSgrnList[0];
        console.log('22', data)
        setCompanyData([data]);
        setGooodsId(data.SgrnId);
        setTableData(data.TrnSgrnList);
        setAllfieldStepperData(data);
        setMode("view");
        viewModeDis();
      } else {
        if (flag !== "D") {
          setMode("add");
          addModeDis();
          toast.error(response.data.Message || "No data found");
        }
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
      setMode("add");
      addModeDis();
      toast.error("Error fetching data");
    }
  };

  const handleAdd = () => {
    addModeDis();
    setMode("add");
    setFlag(false);
    setTableData([]);
    setActiveStep(0);
    setCompanyData([]);
    setAllfieldStepperData({});
    setGooodsId(-1);
  };

  const handlePrevClick = () => {
    fetchGoodsData(GooodsId, "P");
  };

  const handleNextClick = () => {
    fetchGoodsData(GooodsId, "N");
  };

  const handleEdit = async () => {
    try {
      const lockFlag = await checkAndLock(GooodsId, "TrnSgrn", "SgrnId");
      if (lockFlag === 0) {
        setMode("edit");
        addModeDis();
      } else {
        toast.info(lockFlag === 1 ? "Record already locked" : "Failed to lock record");
      }
    } catch (error) {
      toast.error("Error during edit operation");
    }
  };

  const stepToNext = (obj) => {
    setAllfieldStepperData(obj);
    setActiveStep(1);
  };

  const handleDelete = async () => {
    try {
      const lockFlag = await checkAndLock(GooodsId, "TrnSgrn", "SgrnId");
      if (lockFlag === 0) {
        setopenDialog(true);
      } else {
        toast.info(lockFlag === 1 ? "Record already locked" : "Failed to lock record");
      }
    } catch (error) {
      toast.error("Error initiating delete");
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await axiosInstance.post("TrnSgrn/RetriveTrnSgrnAll", {
        SgrnId: GooodsId,
        Flag: "D",
        "CreatedBy": UserId,
      });

      if (response.data.Status === 0) {
        toast.success(response.data.Message);
        await UnLock(GooodsId, "TrnSgrn", "SgrnId");
        fetchGoodsData(1, "L");
      } else {
        toast.error(response.data.Message || "Failed to delete");
      }
    } catch (error) {
      toast.error("Error deleting record");
    } finally {
      setopenDialog(false);
    }
  };

  const handleMoveBack = () => {
    navigate(`/inventory/grntable`);
  };

  const handleStepClick = (step) => {
    if (mode === "view" && !AllButtonDisabled) {
      setActiveStep(step);
    }
  };


  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  const reportColumns = [
    { id: 'ItmCatName', label: 'Category' },
    { id: 'ItmGrpName', label: 'Group' },
    { id: 'ItmSubGrpName', label: 'SubGroup' },
    { id: 'ItmName', label: 'Item Name' },
    { id: 'UnitName', label: 'Unit' },
    { id: 'Quantity', label: 'Quantity' },
    { id: 'Rate', label: 'Rate' },
    { id: 'Amount', label: 'Amount' },
  ];
  return (
    <Grid>
      <ToastContainer />
      <Box className="form-container" >
        <Dialog
          open={openDialog}
          onClose={handleCancel}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": { backgroundColor: "#1565c0", color: "white" },
              }}
              onClick={handleConfirmDelete}
            >
              Yes
            </Button>
            <Button
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": { backgroundColor: "#1565c0", color: "white" },
              }}
              onClick={handleCancel}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
        <Grid container spacing={2} className="rasidant_grid">
          <Grid item xs={12} className='form_title'
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '8px',
              flexDirection: { xs: 'column', sm: 'row', md: 'row' }
            }}
          >
            <Grid sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-start' }, marginBottom: { xs: '10px', sm: 0 } }}>
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={AllButtonDisabled}
                onClick={handlePrevClick}
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                className='three-d-button-next'
                disabled={AllButtonDisabled}
                onClick={handleNextClick}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography variant="h5" sx={{ margin: 'Auto', textAlign: { xs: 'center', sm: 'center' }, fontSize: { xs: '24px', sm: '18px', md: '24px' } }}>
              {activeStep === 0 ? "Goods Receipt Note" : "Goods Receipt Note"}
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Inward GRN"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onView={handlePrint}
                onExit={handleMoveBack}
                readOnlyMode={!AllButtonDisabled}
                onPrevious={handlePrevClick}
                onNext={handleNextClick}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Stepper activeStep={activeStep} connector={<CustomStepConnector />} alternativeLabel>
              {steps.map((label, index) => (
                <Step key={label} onClick={() => handleStepClick(index)} style={{ cursor: mode === "view" ? "pointer" : "default" }}>
                  <CustomStepLabel StepIconComponent={(props) => (
                    <CustomStepIcon ownerState={{ ...props, active: activeStep === index }}>
                      {index + 1}
                    </CustomStepIcon>
                  )}>
                    {label}
                  </CustomStepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>
          <Grid item xs={12} >
            {activeStep === 0 ? (
              <GRNStep1
                index={Index}
                mode={mode}
                CompanyData={CompanyData}
                AllTextDisabled={AllTextDisabled}
                AllButtonDisabled={AllButtonDisabled}
                viewModeDis={viewModeDis}
                addModeDis={addModeDis}
                stepToNext={stepToNext}
                setMode={setMode}
                AllfieldStepperData={AllfieldStepperData}
                Flag={Flag}
                fetchGoodsData={fetchGoodsData}
                setTableData={setTableData}
                GooodsId={GooodsId}
              />
            ) : (
              <GRNStep2
                TableData={tableData}
                mode={mode}
                setTableData={setTableData}
                AllfieldStepperData={AllfieldStepperData}
                GooodsId={GooodsId}
                setActiveStep={setActiveStep}
                fetchGoodsData={fetchGoodsData}
                viewModeDis={viewModeDis}
                addModeDis={addModeDis}
                setFlag={setFlag}
                IsButtonSubmit={AllTextDisabled}
                UserLoginId={UserLoginId}
                TextDisabledFast={setAllTextDisabled}
              />
            )}
          </Grid>
        </Grid>
      </Box>
      <div style={{ display: 'none' }}>
        <GRNPrintView
          contentRef={contentRef}
          formData={AllfieldStepperData}
          tableData={tableData}
        />
      </div>
      {/* <div style={{ display: 'none' }}>
        { <ReportTable
          columns={reportColumns}
          rows={tableData}
          title="Goods Recipt Notes"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div> */}
    </Grid>
  );
};
export default GRNMst;